export enum EntityType {
    SHOW = 'SHOW',
    MOVIE = 'MOVIE',
    TALENT = 'TALENT',
    SPORTS = 'SPORTS'
  }


// WEBPACK FOOTER //
// ./src/app/common/model/constant.ts